import {Injectable} from "@angular/core";
import {environment} from "environments/environment";
import {Headers, Http} from "@angular/http";
import {Observable} from "rxjs/Observable";
import {ApiEvsService} from "app/common/services/ApiEvs.service";

@Injectable()
export class HistoryBoxService {
  headers: Headers;
  url = environment.qrcode_url;

  constructor(private http: Http, private apiEvsService: ApiEvsService) {
    const token = localStorage.getItem("Access-Token");
    this.headers = new Headers({
      "Accept-Language": localStorage.getItem("lang") || "vi",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
  }
  statistics(): Observable<any> {
    return this.http
      .get(`${this.url}/box/history/overview`, { headers: this.headers })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      });
  }
  getList(query?: any): Observable<any> {
    return this.http
      .get(`${this.url}/box/list`, { headers: this.headers, params: query })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      });
  }
  getDetail(opt: any): Observable<any> {
    return this.http
      .get(`${this.url}/box/detail`, { headers: this.headers, params: opt })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      });
  }
  getListStampInBox(query?: any): Observable<any> {
    return this.http
      .get(`${this.url}/box/stamps`, {
        headers: this.headers,
        params: query,
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      });
  }

  getListBatchesStamp(query?: any): Observable<any> {
    return this.http
      .get(`${this.url}/box/batches`, {
        headers: this.headers,
        params: query,
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      });
  }

  listBoxType(): Observable<any> {
    return this.http
      .get(`${this.url}/box/type`, {headers: this.headers})
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      });
  }

  getDetailUnbox(boxId: any, params: any): Observable<any> {
    return this.http
      .get(`${this.url}/box/exclude/${boxId}`, {headers: this.headers, params: params})
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      });
  }
  deleteBox(boxId: any): Observable<any> {
    return this.http
      .delete(`${this.url}/box/${boxId}`, {headers: this.headers})
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      });
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/history-box/services/history-box.service.ts